<p-toast></p-toast>

<div class="p-3 md:p-5 flex justify-content-center">
  <div class="surface-card p-3 md:p-4 shadow-1 border-1 border-round w-full" style="border-color: #8383833b;">

    <div class="flex flex-wrap align-items-center justify-content-between mb-4 gap-3">
      <div class="flex align-items-center gap-2">
        <div class="youtube-icon flex-shrink-0">
          <i class="pi pi-youtube text-red-600 text-4xl"></i>
        </div>
        <span class="text-xl font-bold text-900">YouTube Integration</span>
      </div>

      @if (!loading()) {
      <p-tag [severity]="status().isConnected ? 'success' : 'warning'"
        [value]="status().isConnected ? 'CONNECTED' : 'NOT CONNECTED'"
        [icon]="status().isConnected ? 'pi pi-check' : 'pi pi-exclamation-triangle'">
      </p-tag>
      }
    </div>

    <div class="border-top-1 surface-border pt-4">

      @if (loading() || isProcessingCode()) {
      <div class="flex flex-column align-items-center gap-3 py-5">
        <p-progressSpinner styleClass="w-3rem h-3rem"></p-progressSpinner>
        <span class="text-600 font-medium">
          {{ isProcessingCode() ? 'Finalizing secure connection...' : 'Checking status...' }}
        </span>
      </div>
      }

      @if (!loading() && !isProcessingCode() && status().isConnected) {
      <div class="text-center">
        <div class="text-900 font-medium mb-2">Integration Active</div>
        <div class="text-600 mb-4 text-sm">
          Your portal is successfully syncing videos from the linked channel.
        </div>

        <p-button label="De-Activate Integration" icon="pi pi-trash"
          styleClass="p-button-danger p-button-outlined w-full" [style]="{'white-space': 'normal', 'height': 'auto'}"
          (onClick)="deintegrate()">
        </p-button>
      </div>
      }

      @if (!loading() && !isProcessingCode() && !status().isConnected) {
      <div class="text-center">
        <div class="text-900 font-medium mb-2">No Channel Linked</div>
        <div class="text-600 mb-4 text-sm">
          Connect a YouTube channel to display its vlogs on the portal.
          You will be redirected to Google to approve access.
        </div>

        <p-button label="Activate Integration" styleClass="my-custom-btn w-full"
          [style]="{'white-space': 'normal', 'height': 'auto'}" (onClick)="initiateIntegration()">
        </p-button>
      </div>
      }

    </div>
  </div>
</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>